export enum DigitalSignatureType {
  CpdActivityHonestyPledge,
}
